<template>
  <div
    v-if="!dataColumns || !dataColumns.length"
    class="text-center padding-md font-weight-bold"
    data-test="graphics-sheetsSettings-noData"
  >
    Data Not Found
    <hr />
    Check data providers and ensure data is synced and available
  </div>

  <ul
    v-else
    data-test="graphics-sheetsSettings-columnList"
  >
    <li
      v-for="(col, index) in dataColumns"
      :key="index + col"
      class="sidebar__data-selector-option flex"
      :data-test="`graphics-sheetsSettings-selectColumn-${index}`"
      data-entity="graphics-sheetsSettings-selectColumn"
      @click="mapField(index)"
    >
      <div class="flex-grow">
        Column {{ $filters.sheetColumn(index) }}
      </div>
      <div class="font-style-italic flex-grow">
        {{ col }}
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
  emits: ['update-map'],
  name: 'GoogleSheetsMapPopup',
  props: {
    dataProvider: {
      required: true,
    },
    property: {
      required: true,
    },
  },
  computed: {
    ...mapState({
      sheetsData(state) {
        return state[this.dataProvider?.id]?.sheetsData;
      },
    }),
    dataColumns() {
      if (!this.dataProvider) {
        return [];
      }

      const data = this.sheetsData;
      if (!data || !data.length) {
        return [];
      }

      // TODO: This will need to be updated if we support row indices
      const cols = Math.max(...data.map((r) => r.length));

      const getColumnName = (val) => val?.text || val?.img || '(Blank)';

      // Just use the first row to signify columns
      return Array.from({ length: cols }).map((v, i) => getColumnName(data[0][i]));
    },
  },
  methods: {
    mapField(idx) {
      if (!this.dataProvider) return;

      const data = {
        path: `data.dataKeyMap.${this.property}`,
        value: idx,
        property: this.property,
      };

      this.$emit('update-map', data);
    },
  },
};
</script>
